import { defineAdapter } from "@repo/adapter-core";
import {
  DOMAIN_DEFAULT_CONFIG,
  DOMAIN_LISTING_TYPES,
  DOMAIN_PROPERTY_TYPES,
  DOMAIN_SORT_OPTIONS,
  DOMAIN_TIME_RANGES,
  DomainAdapterConfigSchema,
  resolveDomainConfig,
} from "./config.ts";
import { DOMAIN_ADAPTER_META } from "./meta.ts";
import {
  extractDomainAssets,
  parseDomainDetailHtml,
  parseDomainDiscoveryPreviews,
} from "./parser.ts";
import { buildPaginatedUrl, buildSearchUrl } from "./runtime.ts";

export * from "./config.ts";
export * from "./meta.ts";
export * from "./parser.ts";
export * from "./runtime.ts";

export const DOMAIN_ADAPTER = defineAdapter({
  meta: DOMAIN_ADAPTER_META,
  defaultConfig: DOMAIN_DEFAULT_CONFIG,
  resolvedConfigSchema: DomainAdapterConfigSchema,
  resolveConfig: resolveDomainConfig,
  buildSearchUrl,
  // Search URLs can list sold, for-sale or rental listings: each is its own discovery lane.
  listingTypes: ["buy", "sold", "rent"],
  // A job set to Any crawls for-sale and sold, so a for-sale listing can be followed until it sells.
  anyListingTypes: ["buy", "sold"],
  buildPaginatedUrl,
  // Sold date per search card (2026-10-23, from stored discovery snapshots): restores the
  // discovery-stage date guard that used to come from a Firecrawl JSON extract.
  parseDiscoveryPreviews: parseDomainDiscoveryPreviews,
  // Every Domain detail page embeds the listing's own record in
  // __NEXT_DATA__ (listingByIdV2); raw-HTML providers need it to fill
  // sale date, price, beds and the rest. See parser.ts.
  parseDetailHtml: parseDomainDetailHtml,
  extractAssets: extractDomainAssets,
  // Zyte gets banned on Domain search pages and returns junk on detail pages (2026-09-25/26).
  zyteBlocked: true,
  brightdataOverflow: true,
  listingCards: true,
  // No brightdataDiscoveryFirst: Domain answers Bright Data Web Unlocker search requests with
  // reject_block (measured 2026-09-25 19:4xZ) while Firecrawl returns the full page.
});

export {
  DOMAIN_DEFAULT_CONFIG,
  DOMAIN_LISTING_TYPES,
  DOMAIN_PROPERTY_TYPES,
  DOMAIN_SORT_OPTIONS,
  DOMAIN_TIME_RANGES,
};
